import { Branch } from '@nw/shared/config';

import { branchOptions } from '../../constants/BranchConstants';

export const getBranchOptions = (): Array<Branch> => {
  return branchOptions.map((branch) => {
    return {
      branch_id: branch,
      branch_name: branch
    };
  });
};
